import React from "react";
import "./styles.less";

export const Link = (props) => {
  const { children, ...restProps } = props;
  return (
    <div className="authing-link-icon-warp">
      <a className="authing-link-icon" {...restProps}>
        <span className="authing-link-text">{children}</span>
        <i
          className="icon authing-icon authing-arrow-down-line"
          style={{
            display: "inline-block",
            transform: "rotate(90deg)",
            marginLeft: 6,
            color: "#396aff",
            fontSize: "inherit",
          }}
        ></i>
      </a>
    </div>
  );
};
